const comments = [
  {
    name: '影迷小陈',
    text: '用了555影视半年多了，片源真的很全，新上映的电影基本隔天就能看到高清版本，更新速度没得说。最关键的是完全免费，画质还贼清晰，已经安利给身边所有朋友了！',
    tag: '忠实用户',
  },
  {
    name: '追剧达人Lily',
    text: '之前换了不知道多少个在线看电影的网站，要么卡顿要么画质渣。555影视是我用过最流畅的，不缓冲真的不是口号。手机上看也特别方便，通勤路上追影必备。',
    tag: '移动观影族',
  },
  {
    name: '电影发烧友阿杰',
    text: '作为一个每周看五六部电影的人，555影视的片库深度让我惊喜。不仅有最新大片，很多冷门佳作和经典老片也能找到，而且还按类型、年份整理得很清楚，找片效率翻倍。',
    tag: '资深影迷',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900 mb-3">
            观众心声
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            听听影迷朋友们怎么说555影视
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {comments.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                  <span className="text-accent-700 font-heading text-sm">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                  <span className="inline-block mt-0.5 px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">
                &ldquo;{item.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}